import Vue from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/hu';
import 'dayjs/locale/en';
import i18n from '@/plugins/i18n';

const localTime = (value: Date|string) => dayjs(value).locale(i18n.locale);

Vue.filter('date', (value: Date|string|null): string => {
  if (value === null) {
    return '';
  }

  return localTime(value).format('YYYY.MM.DD.');
});

Vue.filter('datetime', (value: string|null): string => {
  if (value === null) {
    return '';
  }

  return localTime(value).format('YYYY.MM.DD. HH:mm');
});

Vue.filter('time', (seconds: number): string => {
  if (seconds < 60) {
    return `0:${addLeadingZero(seconds)}`;
  }

  const minutes: number = Math.floor(seconds / 60);

  seconds = seconds % 60;
  return `${addLeadingZero(minutes)}:${addLeadingZero(seconds)}`;
});

Vue.filter('strip-tags', stripTags);

Vue.filter('trim', (text: string): string => {
  return text.trim();
});

const addLeadingZero = (value: number) => {
  if (value >= 10) {
    return value;
  }

  return `0${value}`;
};

export function stripTags(text: string): string {
  const div = document.createElement('div');
  div.innerHTML = text;
  return div.innerText.trim();
}